import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LicenseType, Pagination} from '../../../../../services/api/api';
import {ModalService} from '../../../../../services/gui/modal/modal.service';
import {ModalNavigationService} from '../../../../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'licence-management-generate-licences-modal',
  templateUrl: './licence-management-generate-modal.component.html',
  styleUrls: ['./licence-management-generate-modal.component.scss'],
  standalone: false,
})
export class LicenceManagementGenerateModalComponent implements OnInit {
  public count: number;
  public selectedType: string;

  constructor(private modalNavigation: ModalNavigationService) {
    this.count = 1;
    this.selectedType = LicenseType.DeviceLicense;
  }

  ngOnInit(): void {}

  public onTypeSelected(type): void {}

  public onCountChanged(newCount: number): void {
    if (!newCount || newCount < 1) {
      newCount = 1;
    }
    this.count = newCount;
  }

  public generateLicences(): void {
    this.modalNavigation.result({
      type: this.selectedType,
      count: this.count,
    });
  }

  get typeOptions(): string[] {
    return Object.keys(LicenseType);
  }
}
